import React from 'react';

const WebsiteTable = (props) => {
    return (
        <tr key={props.index} className="image" onClick={() => props.editData(props.item)}>
            {
                props.item.logo[0] && props.item.logo[0].url ?
                    <td>
                        <img src={props.item.logo[0].url} alt="" />
                    </td>
                    : 
                    <td>
                        <img src={window.location.origin + "/assets/images/logoblank.png"} alt="" />
                    </td>
            }
            <td>
                {props.item.name}
            </td>
            <td>
                {props.item.email}
            </td>
            <td>
                {props.item.phone}
            </td>
        </tr>
    );
};

export default WebsiteTable;